import { collection, onSnapshot } from 'firebase/firestore';
import { firestore } from '~/firebase/init';

import { CollectionSnapShotFn } from '~/firebase/listeners/type';

export function modifiersListener(storeId: string, onNext: CollectionSnapShotFn) {
  const ref = collection(firestore, 'stores', storeId, 'modifiers');

  return onSnapshot(ref, {
    next: onNext,
    error: () => {
      console.error(`listen stores/${storeId}/modifiers error`);
    },
  });
}
